import UnsupportedOperationError from "./UnsupportedOperationError.mjs";
/**
 * @public
 */
class NotImplementedError extends UnsupportedOperationError {}
export default NotImplementedError;